import { useState, useEffect, useCallback } from 'react';
import { transactionApiService, Transaction, TransactionFilters } from 'services/api';

export const useEmployeeTransactions = (employeeId: string) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    pageSize: 10,
  });

  const fetchTransactions = useCallback(async (filters: TransactionFilters = {}) => {
    if (!employeeId) return;

    try {
      setLoading(true);
      setError(null);
      const response = await transactionApiService.getEmployeeTransactions(employeeId, filters);
      
      if (response.success && response.data) {
        setTransactions(response.data.transactions || []);
        if (response.data.pagination) {
          setPagination(response.data.pagination);
        }
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch transactions');
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  }, [employeeId]);

  const refreshTransactions = useCallback((filters?: TransactionFilters) => {
    return fetchTransactions(filters);
  }, [fetchTransactions]);

  useEffect(() => {
    if (employeeId) {
      fetchTransactions();
    }
  }, [employeeId, fetchTransactions]);

  return {
    transactions,
    loading,
    error,
    pagination,
    fetchTransactions,
    refreshTransactions,
  };
};

